/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import styled, { css } from 'styled-components';

/**
 * Internal dependencies
 */
import { themeHelpers, TextSize } from '../../../theme';
import { defaultTypographyStyle } from '../styles';

export const Headline = styled.h1<{ size: TextSize; as?: React.ElementType }>`
  ${defaultTypographyStyle};

  ${({ theme, size = TextSize.Medium }) =>
    themeHelpers.expandPresetStyles({
      preset: theme.typography.presets.headline[size],
      theme,
    })}
  ${({ as, theme }) =>
    as === 'a' &&
    css`
      :hover {
        color: ${theme.colors.fg.linkHover};
      }

      ${themeHelpers.focusableOutlineCSS(theme.colors.border.focus)}
    `}
`;
